import { putResolve, put } from "redux-saga/effects";
import { uniqueId } from "lodash";

import { addFieldToPage, replaceFieldId as replaceFieldIdInPage } from "./../../pages/actionCreators";
import { duplicateFieldToLayout, replaceFieldInLayout, updateLayoutRequest } from "./../../layout/actionCreators";
import { duplicateFieldSuccess, duplicateFieldWithTempId } from "./../actionCreators";
import { AddFieldResponse, FieldsService } from "./../../../services/fields";
import { DuplicateFieldRequestActionType } from "./../types";
import { duplicateFieldOptions } from "../../selectableOptions/actionCreaters";
import { getFormIdFromUrl } from "../../../helpers/getUrlParams";

export function* duplicateFieldSaga({
    payload: { pageId, fieldId, index, pageFieldsIds, fieldType, options },
}: DuplicateFieldRequestActionType) {
    try {
        const tempId = uniqueId("tempId_");

        yield put(duplicateFieldWithTempId({ fieldId, tempId, index }));
        yield put(addFieldToPage({ pageId, fieldId: tempId }));
        yield put(duplicateFieldToLayout({ fieldId, tempId, pageFieldsIds }));

        const {
            data: { data },
        }: AddFieldResponse = yield FieldsService.duplicateField({
            field_id: fieldId,
            page_id: pageId,
            form_id: getFormIdFromUrl(),
        });
        const realFieldid = data._id;

        if (options) {
            yield put(duplicateFieldOptions({ fieldId: realFieldid, options: options }));
        }
        yield putResolve(duplicateFieldSuccess({ fieldId: realFieldid, tempId }));
        yield putResolve(replaceFieldIdInPage({ fieldId: realFieldid, tempId }));
        yield putResolve(replaceFieldInLayout({ fieldId: realFieldid, tempId }));
        yield putResolve(updateLayoutRequest({}));
    } catch (error) {
        // yield put(Handle Error);
    }
}
